import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { paymentsUrl } from '@findemdev/findem-helpers';
import { IFetchAllUsersResponse } from '../types/users';


export const paymentsApi = createApi({
  reducerPath: 'paymentsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: paymentsUrl,
    credentials: 'include',
  }),
  endpoints: (build) => ({
    fetchAllUsers: build.query<IFetchAllUsersResponse, { joid: string }>({
      query: ({ joid }) => ({
        url: `/api/fetch_users?joid=${joid}`,
        credentials: 'include',
        headers: {
          'content-type': 'application/json',
        },
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchAllUsersQuery } = paymentsApi;